module.exports = __webpack_public_path__ + "static/media/credit-card-blank.2dddc984.svg";